import { useContext } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';

import { Icon, Menu } from '@marketplace/ui-elements';
import { AuthContext, getAuthRedirectURL, logOut } from '@marketplace/common';

type TUseMyAccountMenuItemsArg = {
  profileUrl: string;
  iconClassName: string;
};

export const useHeaderMenu = ({
  profileUrl,
  iconClassName,
}: TUseMyAccountMenuItemsArg) => {
  const { push } = useHistory();
  const { formatMessage } = useIntl();
  const auth = useContext(AuthContext);

  const menuModel = [
    {
      label: formatMessage({ id: 'developer_my_profile' }),
      icon: (
        <Icon
          glyph={Icon.glyphs.svg.user}
          size={Icon.sizes.mini}
          iconClassName={iconClassName}
        />
      ),
      command: () => push(profileUrl),
    },
    {
      label: formatMessage({ id: 'developer_logout' }),
      icon: (
        <Icon
          glyph={Icon.glyphs.svg.logout}
          size={Icon.sizes.tiny}
          iconClassName={iconClassName}
        />
      ),
      command: () => logOut(),
    },
  ];

  return !auth.parsedToken ? (
    <a href={getAuthRedirectURL()}>
      {formatMessage({
        id: 'developer_landing_header_navigation_sign_in',
      })}
    </a>
  ) : (
    <Menu
      label="developer_landing_header_navigation_my_account"
      model={menuModel}
    />
  );
};
